import { useToastList } from '../../lib/useToast.js';

export function ToastHost() {
  const { toasts, dismiss } = useToastList();
  return (
    <div className="toast-host" role="region" aria-live="polite" aria-label="Notifications">
      {toasts.map((t) => (
        <div key={t.id} className={`toast ${t.tone || 'info'}`} data-testid="toast">
          <div className="stack tight" style={{ flex: 1 }}>
            {t.title ? <div className="toast-title">{t.title}</div> : null}
            <div className="toast-body">{t.body}</div>
          </div>
          {t.action ? (
            <button
              className="toast-action"
              onClick={() => {
                t.action?.onClick?.();
                dismiss(t.id);
              }}
            >
              {t.action.label}
            </button>
          ) : null}
          <button
            className="toast-action"
            onClick={() => dismiss(t.id)}
            aria-label="Dismiss notification"
          >
            Dismiss
          </button>
        </div>
      ))}
    </div>
  );
}
